'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.LogosBranding = LogosBranding;
var _base = _interopRequireDefault(require('@emotion/styled/base'));
var _AsurionLogo = _interopRequireDefault(require('./AsurionLogo'));
var _react = require('@emotion/react');
var _jsxRuntime = require('@emotion/react/jsx-runtime');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const styles = {
  logosWrapper:
    process.env.NODE_ENV === 'production'
      ? {
          name: 'o0gatn',
          styles: 'display:flex;gap:10.77px;height:100%;align-items:center',
        }
      : {
          name: '1g1xqm6-logosWrapper',
          styles: 'display:flex;gap:10.77px;height:100%;align-items:center;label:logosWrapper;',
          map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Mb2dvc0JyYW5kaW5nLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTbUIiLCJmaWxlIjoiLi4vc3JjL0xvZ29zQnJhbmRpbmcudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IEFzdXJpb25Mb2dvIGZyb20gJy4vQXN1cmlvbkxvZ28nO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbnRlcmZhY2UgTG9nb3NCcmFuZGluZ1Byb3BzIHtcbiAgcGFydG5lckxvZ286IFJlYWN0LlJlYWN0Tm9kZTtcbn1cblxuY29uc3Qgc3R5bGVzID0ge1xuICBsb2dvc1dyYXBwZXI6IGNzc2BcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGdhcDogMTAuNzdweDtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgYCxcbn07XG5cbmNvbnN0IFZlcnRpY2FsTGluZSA9IHN0eWxlZC5kaXZgXG4gIGJvcmRlcjogMC4zN3B4IHNvbGlkIGdyYXk7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGhlaWdodDogMTAwJTtcbmA7XG5cbmV4cG9ydCBmdW5jdGlvbiBMb2dvc0JyYW5kaW5nKHsgcGFydG5lckxvZ28gfTogTG9nb3NCcmFuZGluZ1Byb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPGRpdiBjc3M9e3N0eWxlcy5sb2dvc1dyYXBwZXJ9IGRhdGEtdGVzdGlkPVwiYXBwLWxvZ29zLWJyYW5kaW5nXCIgY2xhc3NOYW1lPVwiZm9vdGVyLWxvZ29cIj5cbiAgICAgIHtwYXJ0bmVyTG9nb31cbiAgICAgIDxWZXJ0aWNhbExpbmUgLz5cbiAgICAgIDxBc3VyaW9uTG9nbyAvPlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */',
          toString: _EMOTION_STRINGIFIED_CSS_ERROR__,
        },
};
const VerticalLine = (0, _base.default)(
  'div',
  process.env.NODE_ENV === 'production'
    ? {
        target: 'e1mw6pxm0',
      }
    : {
        target: 'e1mw6pxm0',
        label: 'VerticalLine',
      },
)(
  process.env.NODE_ENV === 'production'
    ? {
        name: 'j8fq6v',
        styles: 'border:0.37px solid gray;box-sizing:border-box;height:100%',
      }
    : {
        name: 'j8fq6v',
        styles: 'border:0.37px solid gray;box-sizing:border-box;height:100%',
        map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Mb2dvc0JyYW5kaW5nLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQitCIiwiZmlsZSI6Ii4uL3NyYy9Mb2dvc0JyYW5kaW5nLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBBc3VyaW9uTG9nbyBmcm9tICcuL0FzdXJpb25Mb2dvJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW50ZXJmYWNlIExvZ29zQnJhbmRpbmdQcm9wcyB7XG4gIHBhcnRuZXJMb2dvOiBSZWFjdC5SZWFjdE5vZGU7XG59XG5cbmNvbnN0IHN0eWxlcyA9IHtcbiAgbG9nb3NXcmFwcGVyOiBjc3NgXG4gICAgZGlzcGxheTogZmxleDtcbiAgICBnYXA6IDEwLjc3cHg7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGAsXG59O1xuXG5jb25zdCBWZXJ0aWNhbExpbmUgPSBzdHlsZWQuZGl2YFxuICBib3JkZXI6IDAuMzdweCBzb2xpZCBncmF5O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBoZWlnaHQ6IDEwMCU7XG5gO1xuXG5leHBvcnQgZnVuY3Rpb24gTG9nb3NCcmFuZGluZyh7IHBhcnRuZXJMb2dvIH06IExvZ29zQnJhbmRpbmdQcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXtzdHlsZXMubG9nb3NXcmFwcGVyfSBkYXRhLXRlc3RpZD1cImFwcC1sb2dvcy1icmFuZGluZ1wiIGNsYXNzTmFtZT1cImZvb3Rlci1sb2dvXCI+XG4gICAgICB7cGFydG5lckxvZ299XG4gICAgICA8VmVydGljYWxMaW5lIC8+XG4gICAgICA8QXN1cmlvbkxvZ28gLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn1cbiJdfQ== */',
        toString: _EMOTION_STRINGIFIED_CSS_ERROR__,
      },
);
function LogosBranding(_ref) {
  let { partnerLogo } = _ref;
  return (0, _jsxRuntime.jsxs)('div', {
    css: styles.logosWrapper,
    'data-testid': 'app-logos-branding',
    className: 'footer-logo',
    children: [
      partnerLogo,
      (0, _jsxRuntime.jsx)(VerticalLine, {}),
      (0, _jsxRuntime.jsx)(_AsurionLogo.default, {}),
    ],
  });
}
//# sourceMappingURL=LogosBranding.js.map
